import { useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, AlertTriangle, ArrowRight, Loader2 } from "lucide-react";

export function AiInsightsCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const generate = async () => {
    setLoading(true); setErr("");
    try { const r = await api.get("/ai/insights"); setData(r.data); }
    catch (e) { setErr(e?.response?.data?.detail || "Could not generate insights."); }
    setLoading(false);
  };

  return (
    <Card className="border-border bg-gradient-to-br from-neutral-900 to-neutral-800 text-primary-foreground" data-testid="ai-insights-card">
      <CardContent className="p-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2"><Sparkles size={18} strokeWidth={1.5} className="text-amber-300" /><span className="font-heading font-semibold">HV AI Insights</span></div>
          <Button size="sm" variant="secondary" className="h-8 gap-1.5" onClick={generate} disabled={loading} data-testid="ai-insights-generate">
            {loading ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}{data ? "Refresh" : "Generate"}
          </Button>
        </div>
        {!data && !loading && !err && <p className="text-sm text-white/70 mt-3">Get an AI operations briefing grounded in your live Hundeverket data.</p>}
        {err && <p className="text-sm text-red-300 mt-3">{err}</p>}
        {data && (
          <div className="mt-3 space-y-3 text-sm">
            <p className="text-white/90">{data.summary}</p>
            {data.attention?.length > 0 && (
              <div>
                <div className="text-[11px] uppercase tracking-wide text-amber-300 font-semibold mb-1 flex items-center gap-1"><AlertTriangle size={12} /> Needs attention</div>
                <ul className="space-y-1">{data.attention.map((a, i) => <li key={i} className="text-white/80 flex gap-2"><span className="text-amber-300">•</span>{a}</li>)}</ul>
              </div>
            )}
            {data.next_actions?.length > 0 && (
              <div>
                <div className="text-[11px] uppercase tracking-wide text-white/60 font-semibold mb-1">Suggested actions</div>
                <ul className="space-y-1">{data.next_actions.map((a, i) => <li key={i} className="text-white/80 flex gap-2"><ArrowRight size={13} className="mt-0.5 shrink-0 text-white/50" />{a}</li>)}</ul>
              </div>
            )}
            <p className="text-[10px] text-white/40 pt-1">{data.disclaimer}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
